import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, MenuItem as MUIMenuItem, Typography, } from "@mui/material";
import { Icon } from "../../Icon";
import { convertPxToRem } from "../../../util-functions";
const StyledTextMenuItem = styled(MUIMenuItem, {
    shouldForwardProp: (prop) => prop !== "selected" && prop !== "color",
})(({ theme, selected, color, disabled }) => ({
    "&.MuiMenuItem-root": Object.assign(Object.assign({}, theme.typography.largeText), { fontWeight: selected ? 500 : 400, backgroundColor: selected
            ? theme.palette.green03.main
            : theme.palette.grey02.main, color: disabled
            ? theme.palette.disabledText.main
            : theme.palette[color].main, display: "flex", justifyContent: "space-between", height: convertPxToRem(44), padding: `0 ${convertPxToRem(16)}`, "&:hover": {
            backgroundColor: theme.palette.green03.main,
        }, "&.Mui-selected": {
            backgroundColor: theme.palette.green03.main,
        }, "&:focus-visible": {
            backgroundColor: "none",
            border: `${convertPxToRem(2.5)} solid ${theme.palette.primaryBlack.main}`,
        } }),
}));
const StyledIconItem = styled("span")(() => ({
    display: "flex",
    marginRight: convertPxToRem(12),
}));
const StyledItemContent = styled("div")(() => ({
    display: "flex",
    overflow: "hidden",
}));
export const TextMenuItem = ({ color = "primaryBlackText", disabled = false, displayName, displayValue, iconProps, onClick, selected = false, testId, }) => (_jsxs(StyledTextMenuItem, Object.assign({ "data-testid": testId, value: displayValue, color: color, onClick: onClick, selected: selected, disabled: disabled, tabIndex: 0 }, { children: [_jsxs(StyledItemContent, { children: [iconProps && (_jsx(StyledIconItem, { children: _jsx(Icon, Object.assign({}, iconProps, { fontSize: "medium" })) })), _jsx(Typography, Object.assign({ variant: "largeText", noWrap: true }, { children: displayName }))] }), selected && _jsx(Icon, { iconName: "Checkmark", fontSize: "large" })] }), displayValue));
